/// <reference types="@angular/localize" />

//import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from '@app/app.module';
import {environment} from "@env/environment";
import {enableProdMode} from "@angular/core";

if (environment.production) {
  enableProdMode();
}

//platformBrowserDynamic().bootstrapModule(AppModule)
//  .catch(err => console.error(err));

// Respeta el SSR y evita duplicación
document.addEventListener('DOMContentLoaded', () => {
  platformBrowser()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
});

